import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class FaqAPI {
	// Categories
	async getCategories() {
		return xget<{ categories: PGSchema.faqs_categories[]; count_by_category: Record<string, number> }>("/faq/categories");
	}

	async createCategory(i18n: any) {
		return xhttp<{ category: PGSchema.faqs_categories }>("/faq/categories", "POST", { i18n });
	}

	async updateCategory(id: string, i18n: any) {
		return xhttp<{ category: PGSchema.faqs_categories }>(`/faq/categories/${id}`, "PUT", { i18n });
	}

	async deleteCategory(id: string) {
		return xhttp(`/faq/categories/${id}`, "DELETE");
	}

	// FAQs
	async getFaqs(cid?: string) {
		const query = cid ? `?cid=${cid}` : "";
		return xget<{ faqs: PGSchema.faqs[]; category?: PGSchema.faqs_categories; categories?: PGSchema.faqs_categories[] }>(`/faq${query}`);
	}

	async getFaq(id: string) {
		return xget<{ faq: PGSchema.faqs; category: PGSchema.faqs_categories }>(`/faq/${id}`);
	}

	async createFaq(faq: Partial<PGSchema.faqs>) {
		return xhttp<PGSchema.faqs>("/faq", "POST", faq);
	}

	async updateFaq(id: string, faq: Partial<PGSchema.faqs>) {
		return xhttp<PGSchema.faqs>(`/faq/${id}`, "PUT", faq);
	}

	async deleteFaq(id: string) {
		return xhttp(`/faq/${id}`, "DELETE");
	}
}
